var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Toolbar'),_c('Index'),_c('Skillaz'),_c('Clients'),_c('div',{staticClass:"pipedriveWebForms",attrs:{"data-pd-webforms":"https://pipedrivewebforms.com/form/36135834cb67165530de3fa70237d7266058150"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }